// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"531":"3c0fd05d","815":"cc2c7401","952":"fac5338c"}[chunkId] + ".chunk.css";
};